import { Spinner } from "@nextui-org/react";
import type { ReactNode } from "react";

import PageStaticMetaTags from "@/components/common/PageStaticMetaTags";
import AnonymousMarketing from "@/pages/AnonymousMarketing/AnonymousMarketing";
import useAuth from "@/services/useAuth";

import FavoritesGroups from "./FavoritesGroups";

export default function FavoritesGroupsPage() {
  const { isAuthenticated, isLoading: isAuthLoading } = useAuth();

  let pageContent: ReactNode;
  if (isAuthLoading) {
    pageContent = <Spinner />;
  } else if (!isAuthenticated) {
    pageContent = <AnonymousMarketing datakey="favorites" />;
  } else {
    pageContent = <FavoritesGroups />;
  }

  return (
    <>
      <PageStaticMetaTags pageId="favoritesGroups" data-testid="FavoritesGroups-PageStaticMetaTags" />
      {pageContent}
    </>
  );
}
